var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    d: "M8.555 14.535c2.084-.418 4.778-1.917 4.778-5.794 0-3.527-2.582-5.876-4.439-6.956-.412-.24-.894.076-.894.552v1.22c0 .96-.404 2.715-1.527 3.445-.573.372-1.193-.185-1.262-.865l-.058-.559c-.066-.65-.727-1.044-1.246-.648C2.974 5.642 2 6.887 2 8.741c0 4.741 3.526 5.926 5.289 5.926q.154 0 .322-.01c-.87-.074-2.278-.614-2.278-2.36 0-1.366.997-2.29 1.754-2.74.204-.12.442.036.442.273v.393c0 .3.117.77.393 1.092.314.364.773-.017.81-.496.012-.151.164-.247.295-.171.427.25.973.784.973 1.649 0 1.365-.753 1.993-1.445 2.238"
  })));
};
export default SvgFlame;